import MomentUtils from '@date-io/moment';
import { ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import PropTypes from 'prop-types';
import pickerTheme from './pickerTheme';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';

const PickerType = {
  date: DatePicker,
  time: TimePicker
};

const Picker = (props) => {
  const { type, value, handleChange, minutesStep, className } = props;

  const Component = PickerType[type] || null;
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ThemeProvider theme={pickerTheme}>
        <Component
          value={value}
          handleChange={handleChange}
          minutesStep={minutesStep}
          className={className}
        />
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

Picker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.elementType.isRequired, PropTypes.object.isRequired])
    .isRequired,
  handleChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['date', 'time']).isRequired,
  minutesStep: PropTypes.number,
  className: PropTypes.string
};
Picker.defaultProps = {
  minutesStep: 15,
  className: null
};

export default Picker;
